export enum TagVariants {
  ALERT = 'alert',
  ASSORTED = 'assorted',
  DARK_LIGHT = 'darkLight',
  DISABLED = 'disabled',
  ERROR = 'error',
  LIGHT = 'light',
  MEDIUM = 'medium',
  PRIMARY = 'primary',
  REWARD = 'reward',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
  PROMOTION = 'promotion',
  lightDark1 = 'lightDark1',
}
